import { JwtHelperService } from '@auth0/angular-jwt';
import { User } from './user';

export class AuthFields {
	private jwtHelperService: JwtHelperService;

	constructor(
		public token?: string,
		public refreshToken?: string,
		public loggedInUser?: User,
	) {
		this.loggedInUser = loggedInUser ? new User(loggedInUser) : loggedInUser;
		this.jwtHelperService = new JwtHelperService();
	}

	public isTokenExpired(): boolean {
		return this.isExpired(this.token);
	}

	public isRefreshTokenExpired(): boolean {
		return this.isExpired(this.refreshToken);
	}

	private isExpired(token: string): boolean {
		if (!token) {
			return true;
		}

		const date = this.jwtHelperService.getTokenExpirationDate(token);
		if (!date) {
			return true;
		}

		return date.valueOf() < new Date().valueOf();
	}
}
